import Grid from '@mui/material/Grid';
import Typography from '@mui/material/Typography';
import { leftHeadings } from './ProfB1PdfFormConstants';
import { rightHeading } from '../ProfA1PdfFormConstants';
import { ProfDivider } from '../ProfA1PdfFormCommonUtils';
import FormCheckboxPdf from '../../../common/Forms/FormCheckboxPdf';
import FormTextFieldPdf from '../../../common/Forms/FormTextFieldPdf';
import {
  FormTextField,
  HeaderGrid,
  CheckboxGrid,
  CheckboxValueGrid,
} from './ProfB1PdfFormStyled';

const MappedHeading = ({ heading, index }) => (
  <Typography variant="h4" key={index}>
    {heading}
  </Typography>
);

export const HeaderSectionGrid = ({ episodeID }) => (
  <HeaderGrid container mt={1} mx={2} spacing={1}>
    <Grid item xs={8}>
      {leftHeadings.map((heading, index) => (
        <MappedHeading heading={heading} index={index} />
      ))}
    </Grid>
    <Grid container item xs={4}>
      <Grid item xs={12}>
        <Typography variant="h5">{rightHeading}</Typography>
      </Grid>
      <Grid item xs={12}>
        Episode Id: {episodeID}
      </Grid>
    </Grid>
  </HeaderGrid>
);

export const RenderFieldSectionData = ({ field = [] }) => (
  <Grid container mt={1} mx={2} spacing={1}>
    {field.map((field) => (
      <FieldSectionData field={field} />
    ))}
  </Grid>
);

export const FieldSectionData = ({ field }) => (
  <Grid item xs={field.xs} md={field.md}>
    <Grid item xs={12}>
      <Typography>{field.label}</Typography>
    </Grid>
    <Grid item xs={12}>
      <FormTextFieldPdf defaultValue={field.value} />
    </Grid>
  </Grid>
);

export const ProfB1NoteField = ({ label, value, rows }) => (
  <Grid container mt={1} mx={2} spacing={1}>
    <Grid item xs={12}>
      <FormTextField
        label={label}
        multiline
        disabled
        rows={rows ? rows : 4}
        defaultValue={value}
        InputLabelProps={{
          shrink: true,
        }}
      />
    </Grid>
  </Grid>
);

export const ProfB1CheckBoxData = ({ item = [] }) => {
  const { xs, label, items } = item;
  return (
    <Grid item xs={xs}>
      <Grid item xs={12}>
        <Typography>{label}</Typography>
      </Grid>
      <CheckboxGrid item xs={12}>
        {items.map((item) => (
          <FormCheckboxPdf item={item} />
        ))}
      </CheckboxGrid>
    </Grid>
  );
};

const CheckboxSection = ({ title, value, checkboxes = [] }) => (
  <Grid item container xs={3}>
    <Grid item xs={12}>
      {title}
    </Grid>
    <CheckboxValueGrid item xs={2}>
      {value}
    </CheckboxValueGrid>
    <Grid item xs={10}>
      {checkboxes.map((item, index) => (
        <FormCheckboxPdf item={item} key={index} />
      ))}
    </Grid>
  </Grid>
);

export const AdaGrid = ({ items, veteranCB = [], readingLevelCB = [] }) => (
  <>
    <Grid container mt={1} mx={2} spacing={1}>
      <Grid item container xs={6}>
        {items.map((field, index) => (
          <Grid item xs={field.xs} key={index}>
            {field.content}
          </Grid>
        ))}
      </Grid>
      <CheckboxSection title="Veteran" value="" checkboxes={veteranCB} />
      <CheckboxSection
        title="Reading Level"
        value=""
        checkboxes={readingLevelCB}
      />
    </Grid>
    <ProfDivider xs={12} />
  </>
);

const CccmsData = ({ item, index }) => (
  <Grid item xs={item.xs} key={index}>
    <Typography>{item.label}</Typography>
    <Typography>{item.value}</Typography>
  </Grid>
);

export const CccmsRowGrid = ({ items }) => (
  <>
    <Grid container mt={1} mx={2} spacing={1}>
      {items.map((item, index) => (
        <CccmsData item={item} index={index} />
      ))}
    </Grid>
    <ProfDivider xs={12} />
  </>
);

export const RenderCheckBoxSection = ({ items }) => (
  <>
    <Grid container mt={1} mx={2} spacing={1}>
      {items.map((item) => (
        <ProfB1CheckBoxData item={item} />
      ))}
    </Grid>
    <ProfDivider xs={12} />
  </>
);
